import { Component, OnInit } from '@angular/core';
import { AppInsightsService } from '../shared/services/appinsights/appinsights.service';

@Component({
    selector: 'app-error-maintenance',
    templateUrl: './error-maintenance.component.html'
})
export class ErrorMaintenanceComponent implements OnInit {
  constructor(private appInsightsService: AppInsightsService) { }

  ngOnInit() {
    this.appInsightsService.logPageView('MaintenanceErrorPageComponent');
  }

}
